import { mapMutations, mapGetters, mapActions } from "vuex";
import { itemQuantity } from "../../../api/helpers/shoppingCartHelper.js";
import { calcLoyaltyPoints } from "../../../api/helpers/LoyalityHelper.js";
import uuid from "uuid/v1";
import { scrollModify } from "../../../api/helpers/uiHelper";
export default {
  computed: {
    ...mapGetters([
      "cartItems",
      "applicableLoyalityRule",
      "useStampCollection",
      "getTotalPoints",
      "storeSupportsLoyaltyPoints",
      "currencySign",
    ]),
    isIos() {
      return !!navigator.platform.match(/iPhone|iPod|iPad/) || !!navigator.platform.match(/Mac68K|MacPPC|MacIntel/);
    },
    getPoints() {
      if (this.storeSupportsLoyaltyPoints === true) {
        return this.getTotalPoints;
      } else return null;
    },
    getBasePoints() {
      if (this.storeSupportsLoyaltyPoints === true) {
        return calcLoyaltyPoints(this.applicableLoyalityRule, this.price);
      } else return null;
    },
    getRollIntoPoints() {
      if (this.storeSupportsLoyaltyPoints === true) {
        if (this.selectedRollIntoModiefiers.length == 0)
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.showRollIntoProduct.FixedPriceValue
          );
        else
          return calcLoyaltyPoints(
            this.applicableLoyalityRule,
            this.rollIntoPrice
          );
      } else return null;
    },
    totalPrice() {
      let sum = this.price || 0;
      var that = this;
      this.ModifierGroupsStates.filter((p) => p.quantity > 0).forEach(
        (state) => {
          var modifier = that.modifiers[state.GroupId].Modifiers.filter(
            (p) => p.ID == state.MID
          )[0];
          sum += (this.computePrice(modifier) || 0) * state.quantity;
        }
      );
      return (
        sum * this.quantity + this.rollIntoPrice + (this.forceUpdate ? 0 : 0)
      );
    },
    cartQuantity() {
      var item = { id: this.productId };
      const iq = itemQuantity(item, this.selectedModifiers, this.cartItems);
      return iq + this.quantity;
    },

    maxQuantity() {
      var item = { id: this.category.ProductID || this.productId };
      const iq = itemQuantity(item, this.getModifiers(), this.cartItems);
      return this.maxItemQuantity - iq;
    },
    createModifierObj(modifier) {
      return { md: modifier, count: 1 };
    },
    isDisabledAddCards() {
      return this.toggleRollInto;
    },
  },
  methods: {
    ...mapMutations(["Add_ProductItem"]),
    ...mapActions(["applyPriceTriggers"]),
    fixQuantity(group, checked, md, groupID) {
      if (md && group) {
        if (checked) {
          if (group.IsSingleSel) {
            group.Modifiers.forEach(function(item) {
              item.quantity = 0;
              item.IsSelected = false;
            });
            this.ModifierGroupsStates.filter(
              (p) => p.GroupId == groupID
            ).forEach((state) => {
              state.quantity = 0;
              state.IsSelected = false;
            });
          }
          if (!md.quantity || md.quantity == 0) {
            md.quantity = 1;
            md.IsSelected = true;
          }
        } else {
          md.quantity = 0;
          md.IsSelected = false;
        }
        var state = this.ModifierGroupsStates.filter(
          (p) => p.GroupId == groupID && p.MID == md.ID
        )[0];
        if (state) {
          state.quantity = md.quantity;
          state.IsSelected = md.IsSelected;
        } else {
          state = {
            GroupId: groupID,
            MID: md.ID,
            quantity: md.quantity,
            IsSelected: md.IsSelected,
          };
          this.ModifierGroupsStates.push(state);
        }
      }
      this.$forceUpdate();
    },
    closeModal() {
      this.$parent.closeModal();
    },
    closeModalMobile() {
      // this.toggleRollInto = false;
      // this.$nextTick(() => {
      //   scrollModify(true)
      // });
      this.$nextTick(() => {
        this.$parent.closeModal();
        scrollModify(false);
      });
    },
    distinct(value) {
      let unique = {};
      value.forEach(function(x) {
        if (!unique[x.ID]) {
          //strict
          Object.defineProperty(unique, x.ID, { value: x, enumerable: true });
        }
      });

      return Object.values(unique);
    },
    inc() {
      this.quantity++;
    },
    dec() {
      this.quantity--;
    },
    getModifiers() {
      var selectedModifiers = [];
      this.ModifierGroupsStates.filter((p) => p.quantity > 0).forEach(
        (state) => {
          var that = this;
          selectedModifiers.push({
            ...that.modifiers[state.GroupId].Modifiers.find(
              (p) => p.ID == state.MID
            ),
            quantity: state.quantity,
          });
        }
      );
      return selectedModifiers;
    },
    getModifierValidation(showError = true) {
      var validate = true;
      if (this.$refs.modifiersRefs) {
        validate = this.$refs.modifiersRefs.validate(showError);
      }
      return validate;
    },
    addToCart() {
      if (this.getModifierValidation()) {
        this.Add_ProductItem({
          item: {
            id: this.category.ProductID,
            uniqueId: uuid(),
            itemNote: this.itemNote,
            code: this.product.ProductCode,
            name: this.category.Name,
            description: this.product.ShortDescription,
            photoUrl: this.product.PhotoUrl,
            tax: this.product.TaxRate,
            RewardPoint: this.product.RewardPoint,
            price: this.price,
            categoryId: this.parentCategory.ID,
            categoryName: this.parentCategory.Name,
          },
          quantity: this.quantity,
          PreparationTime: this.product.PreparationTime,
          ProductCategoryIDs: this.product.ProductCategoryIDs,
          ProductTagIDs: this.product.ProductTagIDs,
          modifiers: this.getModifiers(),
        });
        setTimeout(() => {
          this.closeModal();
        }, 100);
        this.applyPriceTriggers();
        this.confirmRollInto({
          id: this.showRollIntoProduct ? this.showRollIntoProduct.ID : null,
          modifiers: this.selectedRollIntoModiefiers,
        });
        this.applyPriceTriggers();
      } else {
        this.$refs.modifiersRefs.showValidation();
      }
    },
    addToCartMobile() {
      if (this.getModifierValidation()) {
        this.Add_ProductItem({
          item: {
            id: this.category.ProductID,
            uniqueId: uuid(),
            itemNote: this.itemNote,
            code: this.product.ProductCode,
            name: this.category.Name,
            description: this.product.ShortDescription,
            photoUrl: this.product.PhotoUrl,
            tax: this.product.TaxRate,
            RewardPoint: this.product.RewardPoint,
            price: this.price,
            categoryId: this.parentCategory.ID,
            categoryName: this.parentCategory.Name,
          },
          quantity: this.quantity,
          PreparationTime: this.product.PreparationTime,
          ProductCategoryIDs: this.product.ProductCategoryIDs,
          ProductTagIDs: this.product.ProductTagIDs,
          modifiers: this.getModifiers(),
        });
        this.$nextTick(() => {
          this.$parent.closeModal();
          scrollModify(false);
        });
        this.applyPriceTriggers();
        this.confirmRollInto({
          id: this.showRollIntoProduct ? this.showRollIntoProduct.ID : null,
          modifiers: this.selectedRollIntoModiefiers,
        });
        this.applyPriceTriggers();
      } else {
        this.$refs.modifiersRefs.showValidation();
      }
    },
    imgHttpError() {
      if (this.$refs.headerImg && this.$refs.headerImg.style)
        this.$refs.headerImg.style.display = "none";
    },
    getSelectedValue(groupID, MId) {
      var state = this.ModifierGroupsStates.filter(
        (p) => p.GroupId == groupID && p.MID == MId
      )[0];
      if (state) return state.IsSelected;
      else return false;
    },

    selectRollIntoModiefiers(modifiers) {
      if (this.selectedModifierForCustomize) {
        this.$set(
          this.selectedModifierForCustomize,
          "selectedSubmodifiers",
          modifiers
        );
        // this.selectedModifierForCustomize.selectedSubmodifiers = modifiers;
        this.selectedModifierForCustomize = null;
      } else this.selectedRollIntoModiefiers = modifiers;
      this.toggleRollInto = false;
    },
    getImageStyle() {
      var styles = this.imageStyles;
      if (this.viewConfig.ImageCenterMode) {
        styles.push({
          "background-image": `url("${this.getProductImage(this.product)}")`,
          "background-size": "contain",
          "background-repeat": "no-repeat",
          "background-position": "center",
          "background-position-x": "center",
        });
        return styles;
      } else {
        styles.push({
          "background-image": `url("${this.getProductImage(this.product)}")`,
        });
        return styles;
      }
    },
    getProductImage(product) {
      if (product.PhotoUrl) return product.PhotoUrl;
      else return null;
    },
    customizeSubmodifier(modifier) {
      this.selectedModifierForCustomize = modifier;
      this.toggleRollInto = true;
      if (this.isIos)
        this.$nextTick(() => {
          scrollModify(true, true);
        });
    },
    computePrice(modifier) {
      var sum = modifier.Price;
      if (modifier.selectedSubmodifiers) {
        modifier.selectedSubmodifiers.forEach((element) => {
          sum += element.Price * element.quantity;
        });
      }
      return sum;
    },
  },
};
